import styled from "styled-components/macro";

export const TabsWrapper = styled.div`
  border-bottom: 1px solid var(--Neutral-8);
  display: flex;
  align-items: center;
  height: 41px;
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 32px;
`;

export const TabButton = styled.div`
  padding: 10px 20px;
  display: flex;
  padding: 10px 20px;
  justify-content: center;
  align-items: center;
  gap: 2px;
  height: 41px;
  cursor: pointer;

  svg {
    margin: 0 2px;
    width: 16px;
    height: 16px;
  }

  span {
    padding: 0 4px;
    color: var(--Neutral-80);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.021px;
    display: flex;
    align-items: center;
  }

  &.active {
    border-radius: 8px 8px 0 0;
    border-bottom: 1px solid var(--Neutral-100);
    background: var(
      --White-96,
      linear-gradient(
        0deg,
        color(display-p3 0.1216 0.1216 0.1216 / 0.04) 0%,
        color(display-p3 0.1216 0.1216 0.1216 / 0.04) 100%
      ),
      color(display-p3 1 1 1)
    );

    span {
      color: var(--Neutral-100);
    }
  }
`;

export const RowActionsMenuWrapper = styled.div`
  position: relative;
  border-radius: 8px;
  background: #fff;
  background: color(display-p3 1 1 1);
  box-shadow:
    0 110px 31px 0 color(display-p3 0 0 0 / 0),
    0 70px 28px 0 color(display-p3 0 0 0 / 0.01),
    0 40px 24px 0 color(display-p3 0 0 0 / 0.05),
    0 18px 18px 0 color(display-p3 0 0 0 / 0.09),
    0 4px 10px 0 color(display-p3 0 0 0 / 0.1);
  z-index: 10;
  padding: 4px;
  width: ${(props) => props.width || 142}px;

  .menu-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    cursor: pointer;
    color: var(--Neutral-100);
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: -0.12px;
  }

  .menu-item:hover {
    background: #f5f5f5;
  }

  .menu-item.danger {
    color: var(--Error-100);
  }
`;

export const RowActionConatiner = styled.div`
  .dropdowm-toggle {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    &:hover {
      background: var(--White-100);
    }
  }
`;
